import React, { useCallback } from 'react';
import { Routes } from '../../Routes';
import { useNavigation } from '../../shared/useNavigation';

export default function UnsubscribeConfirmationSection() {
 
    const nav = useNavigation();

    const gotoLogin = useCallback(() => {
        nav.redirect(Routes.User.Login);
    }, [nav]);

    return (
        <div className="mt-3 container text-center">
            <h1>We're sad to see you go.</h1>
            <p>
               You have been successfully unsubscribed.
            </p>
            <div className="button-row text-center">
                <button type="submit" className="btn btn-primary mt-2 ml-auto mr-auto" onClick={gotoLogin}>
                    ok
                </button>
            </div>
        </div>
    );
}
